import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createObjectCollectionReduceObject } from '../../../../../common/reducers/objectCollection/reducer';

import infoMaterialsCollectionSaga from './sagas/infoMaterialsCollectionSaga';

export default [
  // Lists
  ...createCombineMapItem(
    'infoMaterialsCollection',
    createObjectCollectionReduceObject,
    [infoMaterialsCollectionSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/infoMaterials/reducers/static/collections/reducersMap.js